import {string, number, array, record, nullable, Parser} from '@freckle/parser'

export type TeacherAttrT = {
  firstName: string
  lastName: string
  email: string
}

/* DistrictStudents are constructed based the user-uploaded .csv Files
as opposed to our internal student model
*/
export type DistrictStudentT = {
  firstName: string
  lastName: string
  schoolGrade: number | undefined | null
  sisId: string
  matches: Array<string>
  teachers: Array<TeacherAttrT>
}

export type StudentWithSisMatchesT = {
  firstName: string
  lastName: string
  id: number
  grade: number
  teachers: Array<TeacherAttrT>
  sisMatches: Array<DistrictStudentT>
}

const teacherParser = record({
  firstName: string(),
  lastName: string(),
  email: string()
})

const districtStudentParser = record({
  firstName: string(),
  lastName: string(),
  schoolGrade: nullable(number()),
  sisId: string(),
  matches: array(string()),
  teachers: array(teacherParser)
})

const sisIdMatchStudentParser = record({
  firstName: string(),
  lastName: string(),
  grade: number(),
  id: number(),
  teachers: array(teacherParser),
  sisMatches: array(districtStudentParser)
})

export function parseSisIdMatchStudents(response: unknown): Array<StudentWithSisMatchesT> {
  return Parser.run(response, array(sisIdMatchStudentParser)) as StudentWithSisMatchesT[]
}
